export default {"src":"/_next/static/media/lab-test.6fd3d3bd.svg","height":65,"width":64,"blurWidth":0,"blurHeight":0};